import { Bar, BarChart, Tooltip,Legend, XAxis, YAxis } from "recharts"


const BarrasNivelDeServicio = () => {
    const data = [
        {
            name: 'Enero 1',
            servicio: 80,
          },
          {
            name: 'Enero 2',
            servicio: 87,
          },
          {
            name: 'Enero 3',
            servicio: 77,
          },
          {
            name: 'Enero 4',
            servicio: 97,
          },
          {
            name: 'Enero 5',
            servicio: 88,
          },
          {
            name: 'Enero 6',
            servicio: 92,
          },
          {
            name: 'Enero 7',
            servicio: 84,
          },
          {
            name: 'Enero 8',
            servicio: 95,
          },
          {
            name: 'Enero 9',
            servicio: 90,
          },
          {
            name: 'Enero 10',
            servicio: 89,
          },
          {
            name: 'Enero 11',
            servicio: 80,
          },
          {
            name: 'Enero 12',
            servicio: 87,
          },
          {
            name: 'Enero 13',
            servicio: 77,
          },
          {
            name: 'Enero 14',
            servicio: 97,
          },
          {
            name: 'Enero 15',
            servicio: 88,
          },
          {
            name: 'Enero 16',
            servicio: 92,
          },
          {
            name: 'Enero 17',
            servicio: 84,
          },
          {
            name: 'Enero 18',
            servicio: 95,
          },
          {
            name: 'Enero 19',
            servicio: 90,
          },
          {
            name: 'Enero 20',
            servicio: 89,
          }
      ];

return(
    <div className="mt-2">
        <BarChart
          width={500}
          height={300}
          data={data}
          id="indicadores-graficos"
          margin={{
            top: 10,
            right: 30,
            left: 20,
            bottom: 10,
          }}
        >
          <XAxis dataKey="name" />
          <YAxis />
          <Legend/>
          <Tooltip />
          <Bar dataKey="servicio" fill="#82ca9d" animationDuration={1100} />
        </BarChart>
    </div>

)


}


export default BarrasNivelDeServicio